const ShotOnGoalEvent = ({ event, getPlayerName, getTeamAbbreviation }) => {
    const shootingPlayerId = event.details?.shootingPlayerId;
    const shootingPlayerName = getPlayerName(shootingPlayerId);
    const shootingPlayerTeamId = event.details?.eventOwnerTeamId;
    const shootingPlayerTeamAbbrev = getTeamAbbreviation(shootingPlayerTeamId);
    const shootingPlayerMugshotUrl = shootingPlayerId ? `https://assets.nhle.com/mugs/nhl/20242025/${shootingPlayerTeamAbbrev}/${shootingPlayerId}.png` : null;

    return (
        <div className="flex items-center mb-2">
            <span className="text-sm font-semibold text-gray-700 mr-2">Time:</span>
            <span className="text-sm text-gray-900 mr-2">{event.timeInPeriod}</span>
            <span className="text-sm font-semibold text-gray-700 mr-2">Period:</span>
            <span className="text-sm text-gray-900 mr-2">{event.periodDescriptor.number}</span>
            <span className="text-sm font-semibold text-gray-700 mr-2">{shootingPlayerName}</span>
            {shootingPlayerMugshotUrl && (
                <img
                    src={shootingPlayerMugshotUrl}
                    alt={shootingPlayerName}
                    className="inline-block ml-2 w-8 h-8 rounded-full"
                />
            )}
            <span className="text-sm font-semibold text-gray-700 ml-2">Shot on Goal</span>
        </div>
    );
};

export default ShotOnGoalEvent;